import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  INVALIDATE_STREAM, INVALIDATE_GROUP,
  FETCHING_STREAM_ASSETS_SEARCH_REQUEST, FETCHING_STREAM_ASSETS_SEARCH_SUCCEEDED, FETCHING_STREAM_ASSETS_SEARCH_FAILED,
  FETCHING_SEARCH_STREAMS_REQUEST, FETCHING_SEARCH_STREAMS_SUCCEEDED, FETCHING_SEARCH_STREAMS_FAILED,
  FETCHING_SEARCH_GROUPS_REQUEST, FETCHING_SEARCH_GROUPS_SUCCEEDED, FETCHING_SEARCH_GROUPS_FAILED,
  INVALIDATE_STREAM_ASSETS_SEARCH
}
  from 'constants/actionTypes.jsx';
  import _ from 'lodash'

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  stream: {},
  group: {},
  search: {}
}

const entityState = {
  loading: false,
  item: null
}

const emptySearchResultSlice = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 0,
  totalRecordsCount: 0,
  records: [],
}

const emptySearchScopeState = {
  query: '',
  loadingAssets: false,
  loadingStreams: false,
  loadingGroups: false,
  assets: { ...emptySearchResultSlice },
  streams: { ...emptySearchResultSlice },
  groups: { ...emptySearchResultSlice },
}

const stripHtmlFromText = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  return value.replace(/<[^>]*>/g, '');
}

const normalizeSearchRecord = (record) => {
  if (!record) {
    return record;
  }

  return {
    ...record,
    name: stripHtmlFromText(record.name),
  };
}

const mergeSearchRecords = (existingSlice, response, filterEntityType) => {
  const slice = existingSlice || emptySearchResultSlice;
  let records = [];

  if (_.get(response, 'currentPage') === 0) {
    records = _.get(response, 'records', []);
  } else {
    records = [...(slice.records || []), ..._.get(response, 'records', [])];
  }

  records = _.uniqBy(records, 'id');
  if (filterEntityType) {
    records = records.filter((item) => {
      const entityType = _.get(item, 'entityType');
      return !entityType || entityType === filterEntityType;
    });
  }
  records = records.map(normalizeSearchRecord);

  return {
    currentPage: _.get(response, 'currentPage', 0),
    totalPages: _.get(response, 'totalPages', 0),
    recordsPerPage: _.get(response, 'recordsPerPage', 0),
    totalRecordsCount: _.get(response, 'totalRecordsCount', 0),
    records,
  };
}

const getSearchScopeState = (state, searchScopeKey) => {
  return state.search[searchScopeKey] || emptySearchScopeState;
}

function hubReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_HUB_STREAMS_REQUEST:

      return {
        ...state,
        loading: true,
        invalidated: true
      }

    case FETCHING_HUB_STREAMS_SUCCEEDED:
      const response = action.payload.response;

      return {
        ...state,
        loading: false,
        invalidated: false,
        items: response.sort((a, b) => {
          return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
        })
      }

    case FETCHING_HUB_STREAMS_FAILED:
      return {
        ...state,
        loading: false,
        invalidated: true
      }

    case FETCHING_STREAM_REQUEST:
      var id = action.payload.request.id;
      var stream = state.stream[id] || entityState;
      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: action.payload.page === 0 ? true: false,
            invalidated: true
          }
        }
      }

    case FETCHING_STREAM_SUCCEEDED:

      var id = action.payload.id;
      var stream = state.stream[id] || entityState;

      const responses = action.payload.response;
      var records = responses.records;

      var items = [];
      if(_.get(action,"payload.response.currentPage") === 0){
        items = _.get(action,"payload.response.records",[])
      }
      else{
        items = [...stream.item.children,..._.get(action,"payload.response.records",[])]
      }

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: {
              currentPage: _.get(action,"payload.response.currentPage"),
              totalPages: _.get(action,"payload.response.totalPages"),
              recordsPerPage: _.get(action,"payload.response.recordsPerPage"),
              totalRecordsCount: _.get(action,"payload.response.totalRecordsCount"),
              records:items,
              children: sortedChildren
            }
          }
        }
      }  

    case FETCHING_STREAM_FAILED:
      var id = action.payload.id;
      var stream = state.stream[id] || entityState;

      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: null,
            errors: action.payload.error.errors
          }
        }
      }

    case FETCHING_GROUP_REQUEST:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: true,
            invalidated: true
          }
        }
      }

    case FETCHING_GROUP_SUCCEEDED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      var items = action.payload.response.children || [];

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: false,
            item: {
              ...action.payload.response,
              children: sortedChildren
            }
          }
        }
      }

    case FETCHING_GROUP_FAILED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: true
          }
        }
      }

    case FETCHING_STREAM_ASSETS_SEARCH_REQUEST: {
      var searchScopeKey = action.payload.request.streamId || 'hub';
      var searchState = getSearchScopeState(state, searchScopeKey);
      const resetAssets = action.payload.page === 0;

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            query: action.payload.request.query,
            loadingAssets: true,
            assets: resetAssets ? { ...emptySearchResultSlice } : searchState.assets,
          }
        }
      }
    }

    case FETCHING_STREAM_ASSETS_SEARCH_SUCCEEDED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingAssets: false,
            query: action.payload.query,
            assets: mergeSearchRecords(searchState.assets, action.payload.response, 'asset'),
          }
        }
      }
    }

    case FETCHING_STREAM_ASSETS_SEARCH_FAILED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingAssets: false,
            assets: { ...emptySearchResultSlice },
          }
        }
      }
    }

    case FETCHING_SEARCH_STREAMS_REQUEST: {
      var searchScopeKey = action.payload.request.searchScopeKey || 'hub';
      var searchState = getSearchScopeState(state, searchScopeKey);
      const resetStreams = action.payload.page === 0;

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            query: action.payload.request.query,
            loadingStreams: true,
            streams: resetStreams ? { ...emptySearchResultSlice } : searchState.streams,
          }
        }
      }
    }

    case FETCHING_SEARCH_STREAMS_SUCCEEDED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingStreams: false,
            query: action.payload.query,
            streams: mergeSearchRecords(searchState.streams, action.payload.response, 'stream'),
          }
        }
      }
    }

    case FETCHING_SEARCH_STREAMS_FAILED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingStreams: false,
            streams: { ...emptySearchResultSlice },
          }
        }
      }
    }

    case FETCHING_SEARCH_GROUPS_REQUEST: {
      var searchScopeKey = action.payload.request.streamId;
      var searchState = getSearchScopeState(state, searchScopeKey);
      const resetGroups = action.payload.page === 0;

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            query: action.payload.request.query,
            loadingGroups: true,
            groups: resetGroups ? { ...emptySearchResultSlice } : searchState.groups,
          }
        }
      }
    }

    case FETCHING_SEARCH_GROUPS_SUCCEEDED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingGroups: false,
            query: action.payload.query,
            groups: mergeSearchRecords(searchState.groups, action.payload.response, 'group'),
          }
        }
      }
    }

    case FETCHING_SEARCH_GROUPS_FAILED: {
      var searchScopeKey = action.payload.searchScopeKey;
      var searchState = getSearchScopeState(state, searchScopeKey);

      return {
        ...state,
        search: {
          ...state.search,
          [searchScopeKey]: {
            ...searchState,
            loadingGroups: false,
            groups: { ...emptySearchResultSlice },
          }
        }
      }
    }

    case INVALIDATE_STREAM_ASSETS_SEARCH:
      return {
        ...state,
        search: {},
      }

    case INVALIDATE_STREAM:

      return {
        ...state,
        stream: {},
        group: {},
        search: {},
      }

    case INVALIDATE_GROUP:

      return {
        ...state,
        group: {},
      }

    default:
      return state;
  }
}

export { hubReducer };
